import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { CandidateService } from '../../../service/candidate/candidate.service';
import { Candidate } from '../../../class/candidate';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { config } from '../../../../../../environments/config';
import { ContractService } from '../../../service/contract/contract.service';
import { error } from 'console';
declare var google: any;

@Component({
  selector: 'app-candidate',
  templateUrl: './candidate.component.html',
  styleUrls: ['./candidate.component.scss']
})
export class CandidateComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoCandidate: Candidate;
    public candidate: Candidate;
    public msgs: Message[] = [];
    public options: any;
    public latitude: number;
    public longitude: number;
    public zoom: number;
    public overlays: any[];
    public contractsObservations: any[] = [];

    public apiUrl = config.API_ROOT;

    constructor(
        public candidateService: CandidateService,
        private activatedRoute: ActivatedRoute,
        private mapsAPILoader: MapsAPILoader,
        private contractService: ContractService) {
    }

    ngOnInit() {
        

        if(this.infoCandidate.id !== 0 && (this.infoCandidate.id !== undefined)){
            var promiseLoc = this.candidateService.viewCandidate(this.infoCandidate.id).toPromise().then(
            response =>{
                //console.log(response);
                this.infoCandidate = response.json();
                if (this.infoCandidate.latitude && this.infoCandidate.longitude) {
                    const lat = this.infoCandidate.latitude;
                    const lng = this.infoCandidate.longitude;
                    const position = {
                        lat : lat,
                        lng : lng
                    };
                    this.setPosition(position);
                }
                this.getFinishContractsObservations();
                
            },
            error=>{
                // this.router.navigateByUrl('/pages/selection/candidates');
            });
        }
        
    }

    private setPosition(position) {
        this.latitude = position.lat;
        this.longitude = position.lng;
        this.zoom = 17;
    }

    public addMarker(lat, lng, title) {
        this.longitude = lng;
        this.latitude = lat;
        this.overlays = [];
        this.overlays.push(
            new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                }, title: title}
            )
        );
    }

    public cancelCandidate () {
        this.close.emit(true);
    }

    public gotoAttachmentDocumentProfileSurvey(id) {
        window.open(this.apiUrl + '/document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
    }

    public getFinishContractsObservations(){
        this.contractService.contractsObservations(this.infoCandidate.id).toPromise().then(
            response =>{
                this.contractsObservations = response.json();
            },
            error=>{
                let errorMsg = 'Error';
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: errorMsg  } );
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/candidates/candidate/candidate.component.ts